import React, { Component } from "react";
import moment from "moment";
import underscore from "underscore";
import {
  Row,
  Col,
  Input,
  Radio,
  Button,
  Modal,
  Select,
  Form,
  Table,
  Pagination,
  DatePicker,
  Icon,
  Spin,
  Popconfirm,
} from "antd";
import { api, app } from "../../app";
import TeamSeleted from "../../components/TeamSeleted";
import ShoppingAdd from "./Shopping/shoppingAdd";
import ShoppingDetails from "../../components/ShoppingDetails";

import utils from "../../utils";
import config from "../../config";
// import common from "./common2";
// import common3 from "./common3";
import Highlighter from "react-highlight-words";

const RadioGroup = Radio.Group;
const Option = Select.Option;
const FormItem = Form.Item;

function getIdentityList(tj) {
  const identityList = [
    { val: "1", text: "队员" },
    { val: "2", text: "预备队员" },
    { val: "3", text: "志愿者" },
    { val: "4", text: "离队" },
    { val: "5", text: "清退" },
  ];
  if (tj) {
    return (underscore.find(identityList, (iden) => iden.text === tj) || {})
      .val;
  }
  return identityList;
}

class ProTeamManage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search_name: "vname", // 搜索名称(vname,bsrno)
      search_value: "", // 搜索值
      page: 1, // 分页
      ahegp: 20, // 默认20条一页
      team_loading: true,
      rights: app.getData("rights"),
      rights_duizhang: app.getData("rights_duizhang"),
      all_team: [],
      playerList: [],
      select_team: {},
      edit_modal: false,
      data_loading: true,
      load_index: 0,
      edit_index: -1,
      authorityList: [],
      posttionList: [],
      searchText: "",
      add_modal_visible: false,
      pushwhite_modal_visible: false,
      pushreview_modal_visible: false,
      record_modal_visible: false,
      dataList: [],
      select_team: {},
      detail_data: {},
      edit_id: null,
      team_id: null,
      teamname: null,
      record_id: null,
      dataLevel: "0",
      detail_visible: false,
      total: 0,
      page: 1,
      news_type: "1",
      review_status: "-1",
      class_id: "-1",
      company_id: "-1",
      status: "1",
      PositionList: [],
      Merchandiselist: [],
    };
  }

  /**
   * 设置值
   * @param data
   */
  setData = (data) => app.setStateSync(this, data);

  /**
   * 权限数据
   * @returns {Promise<any>}
   */
  authorityData = async (page) => {
    const params = {
      indexno: app.getData("indexno"),
      account: app.getData("account"),
    };
    let { flag, data, msg, total } = await app.post(api.RightsList, params);
    if (flag === 1) {
      await this.setData({ authorityList: data });
    } else {
      app.alert(msg, "error");
    }
  };

  authorityData2 = async () => {
    const params = {
      indexno: app.getData("indexno"),
      account: app.getData("account"),
      team_id: this.state.select_team.team_id,
      teamname: this.state.select_team.teamname,
    };
    let { flag, data, msg, total } = await app.post(api.RightsList, params);
    // if (data.length > 0) {
    //     data.forEach((e, k) => {
    //         if (e.multeamright_name === null) {
    //             e.multeamright_name = e.rights;
    //         }
    //     })
    // }
    if (flag === 1) {
      // console.log(data);
      await this.setData({ authorityList: data });
    } else {
      app.alert(msg, "error");
    }
  };

  async componentDidMount() {
    this._isMounted = true;
    await this.Enterprise();
    await this.Commodity();
    const innerHeight = document.body.offsetHeight,
      table_height = innerHeight - (78 + 60 + 36 + 60 + 58);
    await this.setData({ table_height });
    window.addEventListener("resize", this.onWindowResize);
    this.teamListData();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onWindowResize);
    this._isMounted = false;
    this.teamListData();
  }

  /**
   * 商品列表
   */
  teamListData = async (select_team, load_index) => {
    await this.setData({ load_index, select_team, data_loading: true });
    const { search_value, class_id, company_id, status } = this.state;
    const params = {
      type: "admin",
      class_id,
      company_id,
      status,
      indexno: app.getData("indexno"),
      account: app.getData("account"),
      limit: this.state.ahegp || 20,
      page: this.state.page || 1,
    };
    let { flag, data, msg, total } = await app.post(api.productList, params);
    if (flag === 1) {
      data.forEach((item) => {
        item.tpList = item.teampositionname
          ? item.teampositionname.split(",")
          : [];
      });
    } else {
      data = [];
      app.alert(msg, "error");
    }
    const state = { total, playerList: utils.addArrayKey(data || []) };
    if (this.state.load_index === load_index) {
      state.data_loading = false;
    }
    await this.setData(state);
  };

  /**
   * 打开发布新闻对话框
   */
  handleOpenAddModal = () => {
    this.setData({ edit_id: null, add_modal_visible: true });
  };
  /**
   * 关闭发布新闻对话框
   */
  handleCloseAddModal = async (flag) => {
    await this.setData({ add_modal_visible: false });
    if (flag) {
      const { select_team, load_index } = this.state;
      this.teamListData(select_team, load_index);
    }
  };
  // /**
  //  * 隐藏添加对话框
  //  * @param add_modal
  //  */
  // handleCloseAddModal = async () => {
  //     await this.setData({ edit_modal: false })
  //     this.props.form.resetFields()
  // }

  /**
   * 职务列表
   **/
  PosttionData = async () => {
    let { flag, data, msg } = await app.post(api.PosttionList);
    if (flag === 1) {
      const rights = app.getData("rights");
      // console.log(rights);
      let posttionList = data;
      if (rights === 1) {
        posttionList.forEach((posttion) => {
          posttion.permiss = null;
        });
      } else if (rights === 2) {
        posttionList.forEach((posttion) => {
          if (posttion.permiss === "province") {
            posttion.permiss = null;
          }
        });
      }
      await this.setData({ posttionList });
    } else {
      app.alert(msg, "error");
    }
    await this.authorityData();
  };

  /**
   * 提交
   * @param e
   */
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        const { select_team } = this.state,
          params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
            team_id: select_team.team_id,
          };
        values.multeamright_id = values.multeamright_id
          ? values.multeamright_id.join(",")
          : "";
        values.team_position_id = values.team_position_id
          ? values.team_position_id.join(",")
          : "";
        if (values.indate) values.indate = values.indate.format("YYYY-MM-DD");
        values = Object.assign(values, params);
        const { flag, msg } = await app.post(api.UserInfoAlter, values);
        if (flag === 1) {
          this.teamListData(select_team, this.state.load_index);
          this.handleCloseAddModal();
          app.alert("修改成功", "success");
        } else {
          app.alert(msg, "error");
        }
        await this.setData({ edit_loading: false });
      }
    });
  };

  onWindowResize = (e) => {
    const { innerHeight } = e.target,
      table_height = innerHeight - (78 + 60 + 36 + 60 + 58);
    this.setData({ table_height });
  };

  /**
   *
   * @constructor
   */
  OpenAddPlayerModal = () => {
    this.setData({ add_modal: true });
  };
  import = () => {};

  // 切换选项
  changeSelect = (e) => {
    // search_value
    if (e == "姓名") {
      this.setState({
        search_name: "vname",
      });
    } else {
      this.setState({
        search_name: "bsrno",
      });
    }
    // console.log(e);
  };

  // 监听输入
  inputMotify = (e) => {
    // search_value
    this.setState({
      search_value: e.target.value,
    });
    // console.log(e.target.value);
  };

  // 去搜索
  toSearchBtn = () => {
    this.setData({ page: 1 });
    const { select_team, load_index } = this.state;
    this.teamListData(select_team, load_index);
  };

  CloseAddPlayerModal = async (flag) => {
    await this.setData({ add_modal: false, add_flush: true });
    await this.setData({ add_flush: false });
    if (flag) {
      const { select_team, load_index } = this.state;
      await this.teamListData(select_team, load_index);
    }
  };

  /**
   * 表格搜索
   * @param dataIndex
   * @returns {{filterDropdown: (function({setSelectedKeys: *, selectedKeys?: *, confirm?: *, clearFilters?: *}): *), filterIcon: (function(*): *), onFilter: (function(*, *): boolean), onFilterDropdownVisibleChange: onFilterDropdownVisibleChange, render: (function(*): *)}}
   */
  getColumnSearchProps = (dataIndex, search_name) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`搜索 ${search_name}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleTableSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          onClick={() => this.handleTableReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          重置
        </Button>
        <Button
          type="primary"
          onClick={() => this.handleTableSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginLeft: 8 }}
        >
          搜索
        </Button>
      </div>
    ),
    filterIcon: (filtered) => <Icon type="search" style={{ color: "#fff" }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    // render: text => (
    //     <Highlighter
    //         highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
    //         searchWords={[this.state.searchText]}
    //         autoEscape
    //         textToHighlight={text.toString()}
    //     />
    // ),
  });

  /**
   * 列表搜索
   * @param selectedKeys
   * @param confirm
   */
  handleTableSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  /**
   * 列表搜索重置
   * @param clearFilters
   */
  handleTableReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };
  // 打开操作详情
  handleOpenDetails = async (edit_id) => {
    this.setData({
      detail_visible: true,
      edit_id,
    });
  };
  /**
   * 关闭详情
   */
  handleCancelDetail = () => {
    this.setData({ detail_visible: false });
  };
  /**
   * 编辑
   * @param edit_id
   */
  handleEdit = async (edit_id) => {
    this.setData({ add_modal_visible: true, edit_id });
  };

  /**
   * 打开操作记录
   * @param record_id
   */
  handleOpenRecord = (record_id) => {
    this.setData({ record_modal_visible: true, record_id, type: 4 });
  };

  /**
   * 关闭操作记录
   */
  handleCancelRecord = () => {
    this.setData({ record_id: null, record_modal_visible: false });
  };

  /**
   * 打开详情
   */
  handleOpenDetail = async (id, type) => {
    await this.setData({ detail_visible: true, detail_loading: true });
    let state = { detail_loading: false };
    if (type) {
      let { flag, data, msg } = await app.post(api.productDetails, {
        news_id: id,
        type,
        indexno: app.getData("indexno"),
        account: app.getData("account"),
      });
      if (flag === 1) {
        state.detail_data = data;
      } else {
        app.alert(msg, "error");
      }
    }
    await this.setData(state);
  };

  // 商品类型
  Commodity = async () => {
    let params = {
        account: app.getData("account"),
      },
      { flag, data, msg } = await app.post(api.productCLassList, params);
    if (flag === 1) {
      this.setData({ Merchandiselist: data });
    } else {
      app.alert(msg, "error");
      return {};
    }
  };

  // 爱心企业
  Enterprise = async () => {
    let params = {
        account: app.getData("account"),
      },
      { flag, data, msg } = await app.post(api.companyListProduct, params);
    if (flag === 1) {
      this.setData({ PositionList: data });
    } else {
      app.alert(msg, "error");
      return {};
    }
  };

  /**
   * 删除
   * @param id
   */
  handleDelete = async (id) => {
    let { flag, msg } = await app.post(api.companyDelete, {
      company_id: id,
      indexno: app.getData("indexno"),
      account: app.getData("account"),
    });
    if (flag === 1) {
      app.alert("删除成功", "success");
      const { page, total } = this.state;
      let tp = parseInt((total - 1) / 20);
      tp = (total - 1) % 20 === 0 ? tp : tp + 1;
      if (tp >= page) {
        tp = page;
      }
      await this.teamListData(tp);
    } else {
      app.alert(msg, "error");
    }
  };
  // 改变页码
  changeAhegp = (q, r) => {
    this.setState({ ahegp: r, page: q });
    const { select_team, load_index } = this.state;
    this.teamListData(select_team, load_index);
  };

  // 改变页码
  changeAhegp2 = (q) => {
    this.setState({ page: q });
    const { select_team, load_index } = this.state;
    this.teamListData(select_team, load_index);
  };

  render() {
    // console.log('10'.indexOf(this.state.rights_duizhang) + "==" + '1'.indexOf(this.state.rights));

    let {
        loading,
        data_loading,
        edit_index,
        add_modal,
        edit_modal,
        edit_loading,
        detail_visible,
        detail_data,
        detail_loading,
        playerList,
        select_team,
        posttionList,
        rights,
        rights_duizhang,
        add_flush,
        total,
        add_modal_visible,
        edit_id,
        team_id,
        teamname,
        record_modal_visible,
        record_id,
        PositionList,
        Merchandiselist,
        type,
      } = this.state,
      columns = [
        {
          title: "商品图",
          dataIndex: "product_img",
          key: "product_img",
          width: "12%",
          render: (img) => {
            if (img) {
              if (img.indexOf(":::") !== -1) {
                let imgs = img.split(":::");
                let src = config.imgUrl + imgs[0];
                return (
                  <a href={src} target="_blank">
                    <img width={80} height={80} src={src} />
                  </a>
                );
              } else {
                let src = config.imgUrl + img;
                return (
                  <a href={src} target="_blank">
                    <img width={80} height={80} src={src} />
                  </a>
                );
              }
            } else {
              return "已清除";
            }
          },
        },
        {
          title: "爱心企业",
          dataIndex: "company_name",
          key: "company_name",
          width: "20%",
          render: (title) => <span title={title}>{title}</span>,
        },
        {
          title: "商品名称",
          dataIndex: "product_name",
          key: "product_name",
          width: "12%",
          render: (product_name) => (
            <span title={product_name}>{product_name}</span>
          ),
        },

        {
          title: "商品类型",
          dataIndex: "class_name",
          key: "class_name",
          width: "12%",
          render: (linkman) => <span title={linkman}>{linkman}</span>,
        },
        {
          title: "兑换积分",
          dataIndex: "coin_integral",
          key: "coin_integral",
          width: "12%",
          render: (linkman_mobile) => (
            <span title={linkman_mobile}>{linkman_mobile}</span>
          ),
        },
        {
          title: "库存",
          dataIndex: "stock",
          key: "stock",
          width: "12%",
          render: (love_value) => <span title={love_value}>{love_value}</span>,
        },
        {
            title: "商品状态",
            dataIndex: "status",
            key: "status",
            width: "12%",
            render: (status) => <span title={status}>{status==1?'上架':'下架'}</span>,
            
        },
        {
          title: "操作",
          dataIndex: "linkman ",
          key: "linkman ",
          width: "15%",
          render: (linkman, { product_id  }) => {
            return (
              <div>
                <div>
                  <Button
                    size="small"
                    type="primary"
                    onClick={() => this.handleOpenDetails(product_id)}
                  >
                    详情
                  </Button>
                </div>
                <div>
                  <Button
                    size="small"
                    type="primary"
                    style={{ marginTop: 10 }}
                    onClick={() => this.handleEdit(product_id)}
                  >
                    编辑
                  </Button>
                </div>
                {/* <Popconfirm
                  placement="bottom"
                  title="确定删除吗？"
                  cancelText="取消"
                  okText="确定"
                  onConfirm={() => this.handleDelete(product_id)}
                >
                  <div>
                    <Button
                      size="small"
                      type="danger"
                      style={{ marginTop: 10 }}
                    >
                      删除
                    </Button>
                  </div>
                </Popconfirm> */}
              </div>
            );
          },
        },
      ],
      formItemLayout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 14 },
      },
      { getFieldDecorator, getFieldValue } = this.props.form,
      table_height = this.state.table_height || 600,
      identityList = getIdentityList(),
      edit_info = playerList[edit_index] || {},
      identity = getFieldValue("identity");
    let reasonItem = null,
      notLK = true,
      { authorityList } = this.state;
    authorityList = app.objectArrayAdd(
      authorityList,
      edit_info.rights,
      (obj) => {
        if (
          authorityList.findIndex(
            (author) => author.multeamright_id === obj.id
          ) === -1
        ) {
          return {
            multeamright_id: obj.id,
            multeamright_name: obj.multeamright,
            disabled: true,
          };
        }
        return null;
      }
    );
    // console.log(this.state.authorityList);

    // this.state.authorityList.forEach((e, k) => {
    //     if (e.multeamright_name == '粤all') {
    //         console.log("有值，位置：" + k);
    //     }
    // })

    if (identity === "4" || identity === "5") {
      notLK = false;
      reasonItem = (
        <FormItem {...formItemLayout} label="身份修改原因">
          {getFieldDecorator("leave_reason", {
            rules: [
              {
                required: true,
                message: "请输入离队/清退 原因！",
              },
            ],
          })(<Input.TextArea placeholder="请填写离队/清退 原因" rows={4} />)}
        </FormItem>
      );
    }
    let rights_edit;
    if (
      this.state.rights == "1" ||
      this.state.rights == "2" ||
      this.state.rights_duizhang == "10"
    ) {
      rights_edit = false;
    } else {
      rights_edit = true;
    }

    const title_box = (e) => {
      return (
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItem: "center",
          }}
        >
          <div>编辑队员信息</div>
          <div style={{ fontWeight: "600" }}>{e || ""}</div>
          <div style={{ width: "100px", height: "1px" }}></div>
        </div>
      );
    };

    function showTotal(total) {
      return `总数：${total}条`;
    }

    return (
      <div className="team-editor pro-team">
        <Row style={{ display: "flex" }}>
          <div className="top-title" style={{ margin: "20px" }}>
            爱心商城管理
          </div>
          {/* <div>
            <Row style={{ color: "red" }}>
            法制宣传由镇管理员发布/编辑，每次发布/编辑都需要审核。
            </Row>
            <Row style={{ color: "red" }}>
              {" "}
              法制宣传由镇管理员审核，审核通过后方可对外展示。
            </Row>
          </div> */}
        </Row>
        <Row className="content">
          {/* <Col span={5} className="team-select">
                        <TeamSeleted handleData={this.teamListData} />
                    </Col> */}
          <Col span={21} offset={1} className="team-table">
            <Table
              className="ranks_table"
              title={() => {
                return (
                  <Row className="pro-table-title">
                    <Col span={18} style={{ display: "flex",padding:'0 10px' }}>
                      <div>
                        <span>爱心企业：</span>
                        <Select
                          defaultValue="-1"
                          style={{ width: 240 }}
                          onChange={async (value) => {
                            await this.setData({ company_id: value });
                            await this.teamListData();
                          }}
                        >
                          <Option value="-1">全部</Option>
                          {PositionList.length > 0 &&
                            PositionList.map((item, index) => (
                              <Option
                                key={item.company_id}
                                value={item.company_id}
                              >
                                {item.company_name}
                              </Option>
                            ))}
                        </Select>
                      </div>
                      <div style={{ margin: "0 20px" }}>
                        <span>商品类型：</span>
                        <Select
                          defaultValue="-1"
                          style={{ width: 120 }}
                          onChange={async (value) => {
                            await this.setData({ class_id: value });
                            await this.teamListData();
                          }}
                        >
                          <Option value="-1">全部</Option>
                          {Merchandiselist.length > 0 &&
                            Merchandiselist.map((item, index) => (
                              <Option key={item.class_id} value={item.class_id}>
                                {item.class_name}
                              </Option>
                            ))}
                        </Select>
                      </div>
                      <div>
                        <span>商品状态：</span>
                        <Select
                          defaultValue="1"
                          style={{ width: 120 }}
                          onChange={async (value) => {
                            await this.setData({ status: value });
                            await this.teamListData();
                          }}
                        >
                          <Option value="-1">全部</Option>
                          <Option value="1">上架</Option>
                          <Option value="0">下架</Option>
                        </Select>
                      </div>
                    </Col>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <Button type="primary" onClick={this.handleOpenAddModal}>
                        添加商品
                      </Button>
                    </Col>
                  </Row>
                );
              }}
              locale={app.tbLocale(loading)}
              columns={columns}
              dataSource={playerList}
              loading={data_loading}
              scroll={{ y: table_height, x: 1350 }}
              size="small"
              pagination={false}
              // pagination={{

              // }}
            />
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Pagination
                style={{ marginTop: 16 }}
                current={this.state.page}
                defaultCurrent={1}
                total={total}
                showTotal={showTotal}
                defaultPageSize={20}
                pageSizeOptions={["20", "50", "100"]}
                showSizeChanger={true}
                size="default"
                onShowSizeChange={(e, a) => this.changeAhegp(e, a)}
                onChange={(e) => this.changeAhegp2(e)}
              />
            </div>
            <Modal
              visible={detail_visible}
              footer={null}
              title="商品详情"
              maskClosable={false}
              destroyOnClose={true}
              width={1000}
              bodyStyle={{
                height: "calc(100vh - 100px)",
                overflowY: "auto",
                minHeight: 400,
                position: "relative",
              }}
              style={{ top: 20, paddingBottom: 20 }}
              onCancel={this.handleCancelDetail}
              zIndex={1010}
              className="news-detail-modal-class"
            >
              <ShoppingDetails
                edit_id={edit_id}
                onClose={this.handleCancelDetail}
              />
            </Modal>
            <Modal
              visible={add_modal_visible}
              title={
                <div>
                  {edit_id ? "编辑商品" : "添加商品"}
                  {/* <span style={{ marginLeft: 40, color: "red", fontSize: 13 }}>
                    请勿发布敏感词语或敏感图片
                  </span> */}
                </div>
              }
              footer={null}
              maskClosable={false}
              destroyOnClose={true}
              onCancel={this.handleCloseAddModal}
              width={1000}
              bodyStyle={{
                height: "calc(100vh - 100px)",
                overflowY: "auto",
                minHeight: 400,
                position: "relative",
              }}
              style={{ top: 20, paddingBottom: 20 }}
            >
              <ShoppingAdd
                edit_id={edit_id}
                onClose={this.handleCloseAddModal}
              />
            </Modal>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Form.create()(ProTeamManage);



// WEBPACK FOOTER //
// ./src/routes/grade/shopping.jsx